import {Fragment} from 'react'
import {t} from '@eitje/bridge'

let Prompt = null
let Tooltip = Fragment
let Wrapper = Fragment
let clearIcon = null

// LEGACY
let alert = text => console.log(text)
let isScoped = false
let Button = Fragment
let MultiFormWrapper = Fragment
let defaultIcon = null
let tooltipElement = null

let config = {}

const setup = rest => {
	if (rest.Prompt) Prompt = rest.Prompt
	if (rest.Tooltip) Tooltip = rest.Tooltip
	if (rest.Wrapper) Wrapper = rest.Wrapper
	if (rest.clearIcon) clearIcon = rest.clearIcon

	// LEGACY
	if (rest.alertFunc) alert = rest.alertFunc
	if (rest.scoped) isScoped = rest.scoped
	if (rest.Button) Button = rest.Button
	if (rest.MultiFormWrapper) MultiFormWrapper = rest.MultiFormWrapper
	if (rest.defaultIcon) defaultIcon = rest.defaultIcon
	if (rest.tooltipElement) tooltipElement = rest.tooltipElement

	config = {...config, ...rest}
}
export {config, t, Prompt, Tooltip, Wrapper, clearIcon}

// LEGACY
export {isScoped, Button, MultiFormWrapper, alert, defaultIcon, tooltipElement}

export default setup
